import { GraphQLClient } from 'graphql-request'

import packageJson from '../../../package.json'

const version = process.env.NEXT_PUBLIC_VERSION ?? 'dev'

const requestHeaders = {
  authorization: '',
  'x-graphql-client-name': packageJson.name,
  'x-graphql-client-version': version,
}

const gqlRequestClient = new GraphQLClient(
  `${process.env.NEXT_PUBLIC_PROXIED_API_URL ?? process.env.NEXT_PUBLIC_API}/graphql` as string,
  {
    headers: requestHeaders,
    credentials: 'include',
  },
)

export const gqlRequestClientSSR = (
  cookies?: Partial<{
    [key: string]: string
  }>,
) =>
  new GraphQLClient(`${process.env.NEXT_PUBLIC_API}/graphql` as string, {
    headers: {
      ...requestHeaders,
      ...(cookies && {
        cookie: Object.entries(cookies)
          .map(([key, value]) => `${key}=${value}`)
          .join('; '),
      }),
    },
  })

export default gqlRequestClient
